var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { createPopper } from '@popperjs/core/lib/popper-lite.js';
let ElementDropdown = class ElementDropdown extends LitElement {
    constructor() {
        super(...arguments);
        this.popper = null;
    }
    static get styles() {
        return css `
      :host {
        display: contents;
      }
    `;
    }
    connectedCallback() {
        document.addEventListener('click', (event) => {
            if (!this.contains(event.target)) {
                this.hide();
            }
        });
        super.connectedCallback();
    }
    containerSlotReady(event) {
        const containers = event.target.assignedElements();
        console.assert(containers.length === 1, 'Only one container element is allowed');
        this.containerElement = containers.at(0);
        this.hide();
    }
    toggleSlotReady(event) {
        const toggles = event.target.assignedElements();
        console.assert(toggles.length === 1, 'Only one toggle element is allowed');
        this.toggleElement = toggles.at(0);
    }
    show() {
        this.containerElement.classList.remove('hidden');
        console.assert(this.popper === null, 'Popper already initialized');
        this.popper = createPopper(this.toggleElement, this.containerElement, {
            placement: 'bottom-end',
        });
    }
    hide() {
        this.containerElement.classList.add('hidden');
        if (this.popper) {
            this.popper.destroy();
            this.popper = null;
        }
    }
    toggle() {
        if (this.containerElement.classList.contains('hidden')) {
            this.show();
        }
        else {
            this.hide();
        }
    }
    render() {
        return html `
      <slot
        @slotchange="${this.toggleSlotReady}"
        @click="${this.toggle}"
        name="toggle"
      ></slot>
      <slot @slotchange="${this.containerSlotReady}"></slot>
    `;
    }
};
ElementDropdown = __decorate([
    customElement('element-dropdown')
], ElementDropdown);
export { ElementDropdown };
//# sourceMappingURL=element-dropdown.js.map